import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-report-engine',
  templateUrl: './report-engine.component.html',
  styleUrls: ['./report-engine.component.less'],
})
export class ReportEngineComponent implements OnInit {
  reportId: number;
  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe((params: { reportId: number }) => {
      this.reportId = null;
      setTimeout(() => {
        this.reportId = params.reportId;
      }, 20);
    });
  }

  ngOnInit(): void {}
}
